import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54eb89e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "semi-bold anek c-dark-blue" }


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    isSold: { type: Boolean }
  },
  setup(__props: any) {

/**
 * @author Irakli Kandelaki
 */

// PROPS







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["house-selection__button flex al-center j-center br-13 bg-white", { 'is-sold': __props.isSold }])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1)
  ], 2))
}
}

})